var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
import { toast } from "sonner";
import dayjs from "dayjs";
export const useAutomationsModal = create((set, get) => ({
    open: false,
    setOpen: (op) => set({ open: op }),
    automations: [],
    selectedAutomation: null,
    getAllAutomations: (backend, dashboardId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!backend || !dashboardId)
            return;
        const response = yield backend.automations.list({
            dashboard: dashboardId,
        });
        set({ automations: response });
        if (response.length > 0 && !((_a = get().selectedAutomation) === null || _a === void 0 ? void 0 : _a.id)) {
            get().setSelectedAutomation(response[0]);
        }
    }),
    createAutomation: (backend, dashboard, automations, account, embedUser) => __awaiter(void 0, void 0, void 0, function* () {
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            let newAutomation = yield (backend === null || backend === void 0 ? void 0 : backend.automations.create({
                title: "Automation " + (automations.length + 1),
                description: "",
                dashboard: dashboard === null || dashboard === void 0 ? void 0 : dashboard.id,
                schedule: "0 9 * * 1",
                enabled: true,
                output_format: "pdf",
                method: "email",
                email_body: "Hello!<br /><br/>Here is your automated email from Onvo AI.",
                email_subject: "",
                email_cc: [],
                email_to: (account === null || account === void 0 ? void 0 : account.email) || (embedUser === null || embedUser === void 0 ? void 0 : embedUser.email),
                timezone: dayjs.tz.guess().replace("Calcutta", "Kolkata")
            }));
            yield get().getAllAutomations(backend, dashboard.id);
            return newAutomation;
        }), {
            loading: "Creating automation...",
            success: (newAutomation) => {
                get().setSelectedAutomation(newAutomation || null);
                return "Automation created";
            },
            error: (e) => {
                return "Error creating automation: " + e.message;
            }
        });
    }),
    saveAutomation: () => __awaiter(void 0, void 0, void 0, function* () { }),
    setSelectedAutomation: (updatedAutomation) => {
        if (updatedAutomation === null)
            return set({ selectedAutomation: null });
        let automation = get().selectedAutomation;
        set({
            selectedAutomation: Object.assign(Object.assign({}, automation), updatedAutomation)
        });
    }
}));
//# sourceMappingURL=useAutomationsModal.js.map